<template>
    <div>
        <form novalidate @input="updateFlagsIfEventEdit()">
            <div class="row" style="">
                <div class="col-sm-12" style="margin-left: 0; padding: 0 2rem;">
                    <checkbox class="my-2" v-model="prices[0].isTaxIncludedInPrice" @input="priceIncludeTaxesChanged" :disabled="disabled">
                        <span class="normal">
                            Price include taxes.
                        </span>
                    </checkbox>
                </div>
            </div>

            <div class="mb-4" style="padding:0; margin-left: 0; margin-right: 0;">
                <div class="col-sm-4" :class="isPriceTypeDisabled ? 'mb-1' : 'mb-3'">
                    <v-select
                        v-if="types"
                        v-model="selectedPrincingType"
                        :class="{'notAllowed': isPriceTypeDisabled || disabled}"
                        :options="types"
                        label="description"
                        placeholder="- Select type -"
                        :disabled="disabled || isPriceTypeDisabled"
                        @input="updateType(selectedPrincingType)">
                    </v-select>
                </div>

                <div class="ml-3 mb-3" v-if="isPriceTypeDisabled">
                    <span v-if="priceType === 'event'" class="fs-small color-1">Ticket type can only be edited in the product</span>
                    <span v-if="priceType === 'product'" class="fs-small color-1">This schedule already has reservations. To change the Ticket Type, please cancel all reservations first.</span>
                </div>

                <!-- PER ORDER -->
                <div class="col-sm-12 mt-3" style="background: #ffffff; border-top: 1px solid #DBDFE2;" v-if="selectedPrincingType && selectedPrincingType.id === PricingTypes.PerOrder">
                    <div class="row pt-3">

                        <div class="col-sm-3">
                            <label class="full">Tax</label>
                            <!-- If the price is composit we will show the VAT's of the child items -->
                            <input type="text" disabled="disabled" :value="customPerPersonTaxes(prices[0].productGenderPriceComponents)" class="w-100" v-if="prices[0].productGenderPriceComponents && prices[0].productGenderPriceComponents.length > 0" />
                            <v-select
                                v-else-if="taxes"
                                v-model="prices[0].vatTypeHelper"
                                :options="taxes"
                                label="description"
                                placeholder="- Select tax -"
                                :disabled="disabled"
                                @input="updateTaxType(prices[0], prices[0].vatTypeHelper)">
                            </v-select>
                        </div>

                        <div class="" v-if="perOrderReferenceGenderPrice">
                            <label class="full">Price</label>
                            <div class="d-flex align-items-center">
                                <div v-if="perOrderReferenceGenderPrice.productGenderPriceComponents && perOrderReferenceGenderPrice.productGenderPriceComponents.length > 0">
                                    <div v-if="perOrderReferenceGenderPrice.componentRuleType == 0" class="d-flex" >
                                        <input type="text" :disabled="perOrderReferenceGenderPrice.componentRuleType == 0 || disabled" :value="customPerPersonTotal(perOrderReferenceGenderPrice.productGenderPriceComponents)+' €'" style="width: 6rem;" />
                                    </div>
                                    <div class="d-flex" v-else>
                                        <input type="number" v-model="prices[0].value" :disabled="disabled" style="width: 6rem;" class="glued-right" />
                                        <div class="glued-left">€</div>
                                    </div>
                                </div>

                                <div class="d-flex" v-else>
                                    <input :disabled="disabled" class="glued-right" type="number" v-model="prices[0].value" style="width: 4rem;">
                                    <div class="glued-left">€</div>
                                </div>

                                <i class="fas fa-calculator fs-large medium ml-3" :class="{'pointer':!disabled, 'notAllowed':disabled, 'dark': hasDecomposedPrices}" v-tooltip="'Edit'" @click="openEditPrice(perOrderReferenceGenderPrice)"></i>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <!-- Gender prices -->
                        <div class="col-sm-12 mt-3">
                            <div class="pricesRowHolder">
                                <div class="mt-2 mb-3 pb-3 border-bottom-medium" v-for="pricePerPerson, index in prices" :key="index">
                                    <div v-if="pricePerPerson.isExcludedFromBilling">
                                        <!-- Index 0 is reserved/hidden because the 0 is the "ghost" gender price that has the price -->
                                        <PriceManagerRow  :disabled="disabled" :pricePerPerson="pricePerPerson" @delete="deletePrincingType(index)" @updatedCustomInput="validateCustomNames()" :pricePerOrder="true" :audienceTypes="genderPricesAvailableOptions" :prices="prices" :editingEvent="isEventEditMode" />
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-sm-12 pb-3">
                                    <div class="add d-flex align-items-center fs-small bold" :class="{'pointer':!disabled, 'notAllowed':disabled}" @click="addRow">
                                        <i class="ico-add fs-smallest add-circle color-1"></i> Add price category
                                    </div>
                                    <div v-if="!isPerOrderAudienceValid" class="mt-2">
                                        <span class="fs-small error">At least one price category is required when using Per Order ticket type.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PRICE PER GROUP -->
                     <div class="col-sm-12 py-3" style="background: #ffffff; border-top: 1px solid #DBDFE2;" v-if="selectedPrincingType && selectedPrincingType.id === PricingTypes.PerGroup">
                         <PricePerGroup :disabled="disabled" :prices="prices" :hasDecomposedPrices="hasDecomposedPrices" :priceGroup="audienceTypeGroups" :group="group" :editingEvent="isEventEditMode" @validatePriceGroupDecomposition="hasPriceGroupDecompositionError"/>
                   <!-- :perOrderReferenceGenderPrice="perOrderReferenceGenderPrice" -->
                </div>

                <!-- PER PERSON -->
                <div class="row pt-2" v-if="selectedPrincingType.id !== PricingTypes.PerGroup" :class="{'price-group-wrapper': selectedPrincingType && selectedPrincingType.id !== PricingTypes.PerGroup}" v-for="priceGroup, index in audienceTypeGroups" :key="index">
                    <div class="price-group-item col-sm-12" v-if="priceGroup.groupName != null || priceGroup.groupName != undefined">
                        <div class="price-group-item-header" v-if="selectedPrincingType && selectedPrincingType.id === PricingTypes.PerPerson && priceGroup.groupName != null">
                            <div class="col-sm-12 pt-3 pb-3"  :class="{'pointer':!disabled, 'notAllowed':disabled}">
                                <i @click="removeGroupOfPrices(priceGroup)" class="float-right ico-delete fs-large medium pointer removeSchedule"  v-tooltip="'Remove'"></i>
                                <label class="full">Group Name</label>
                                <input :class="{'error-field': priceGroup.repeatedName}" type="text" style="width: 100%;"
									:disabled="disabled"
									v-model="priceGroup.groupName"
									@input="changePricesAudienceTypeGroupNames(priceGroup, index)"
									placeholder="Custom Price Group"
								/>

                                <span v-if="!disabled && selectedPrincingType && selectedPrincingType.id === PricingTypes.PerPerson">
									<div v-if="priceGroup.repeatedName" class="error">
										<span>The group name should be unique</span>
									</div>
									<div v-else-if="priceGroup.isEmptyName" class="error">
										<span>You must add a group name</span>
									</div>
								</span>
                            </div>
                        </div>
                    </div>
                    <PriceGroup @deletepg="deletePrincingTypePG($event)" @updatedCustomInput="validateCustomNames()" :currentGroupNameProp="priceGroup.groupName" :priceGroup="priceGroup" :audienceTypeGroups="audienceTypeGroups" :value="value" :disabled="disabled || priceGroup.repeatedName" :editingEvent="isEventEditMode" :backupedPricingType="backupedPricingType" :group="group" :selectedPrincingType="selectedPrincingType" v-if="selectedPrincingType && selectedPrincingType.id === PricingTypes.PerPerson" />
                </div>
                <div class="pt-3" style="border-top: 1px solid #dbdfe2;" v-if="selectedPrincingType && selectedPrincingType.id === PricingTypes.PerPerson">
                    <div class="col-sm-12">
                        <div class="add d-flex align-items-center fs-small bold" :class="{'pointer':!disabled, 'notAllowed':disabled}" @click="addNewCustomPriceGroup">
                            <i class="ico-add fs-smallest add-circle color-1"></i> Add new Custom Price Group
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import { mapActions, mapGetters } from 'vuex'
import PriceGroup from '@/components/inventory/products/components/pricingManager/PriceGroup'
import PriceManagerRow from '@/components/inventory/products/components/pricingManager/priceRow.vue'
import PricePerGroup from '@/components/inventory/products/components/pricingManager/PricePerGroup.vue'
import { priceManagerMixin } from '@/mixins/priceManager'
import _ from 'lodash'
import { PricingTypes } from '@/enums/pricingType'
import { isPerOrderAudienceValid} from '@/utils/pricingTypeHelpers'

export default {
    data() {
        return {
            selectedPrincingType: null,
            hasBackupedPricingType: null, // used to set temporary value
            audienceTypeSelected: null,
            currentGroupNameProp: null,
			currentGroupNameIndex: null,
            audienceTypeGroups: null,
			isFormValid: true,
            PricingTypes,
        }
    },
    mixins: [
        priceManagerMixin
    ],
    props: {
        value: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isEventEditMode: {
            type: Boolean,
            default: false
        },
        backupedPricingType: {
            type: Object,
            default: null
        },
        group: {
            type: Object,
            default: null
        },
        priceTypeConfig: {
            type: Object,
            default: null
        }
    },
    created() {
        if (this.prices) {
            // Set the audience type groups for the first time
            this.audienceTypeGroups = this.groupPricesBy(this.prices, 'audienceTypeGroup');

            this.setGroupPrices(this.prices);

            if (this.audienceTypeGroups.length > 0) {
                this.validateGenderPriceNames(this.audienceTypeGroups);
            }

            for (let pricingRow of this.prices) {
                this.$set(pricingRow, 'vatTypeHelper', this.taxes.filter(audienceType => audienceType.id == pricingRow.vatType )[0]);
                this.$set(pricingRow, 'audienceTypeHelper', this.getAudienceTypeList.filter(audienceType => audienceType.id == pricingRow.audienceType)[0]);
                this.$set(pricingRow, 'audienceTypeAssossiationHelper', this.getAudienceTypeList.filter(audienceType => audienceType.id == pricingRow.audienceTypeAssossiation)[0]);
                if (pricingRow.componentRuleType == null) {
                    pricingRow.componentRuleType = 0;
                }
            }
            if (this.group && this.group.backupGroup && this.group.backupGroup.productGenderPrices) {
                this.group.backupGroup.productGenderPrices = JSON.parse(JSON.stringify(this.prices));
            }

            this.markRepeatedCustomNames();
        }
        // Seed initial validity state
        this.$nextTick(() => {
            this.recomputeAndEmitValidity();
        });
    },
    mounted() {
        if (
            this.group &&
            this.group.backupGroup &&
            this.group.backupGroup.productGenderPrices &&
            typeof this.group.selectedPrincingType !== 'undefined' &&
            this.group.selectedPrincingType !== null
        ) {
            this.group.backupGroup.selectedPrincingType = JSON.parse(JSON.stringify(this.group.selectedPrincingType));
        }
    },
    watch: {
        prices() {
            // Set the audience type groups on prices change
            this.audienceTypeGroups = this.groupPricesBy(this.prices, 'audienceTypeGroup');

            for (let pricingRow of this.prices) {
                this.$set(pricingRow, 'vatTypeHelper', this.taxes.filter(audienceType => audienceType.id == pricingRow.vatType)[0]);
                this.$set(pricingRow, 'audienceTypeHelper', this.getAudienceTypeList.filter(audienceType => audienceType.id == pricingRow.audienceType)[0]);
                this.$set(pricingRow, 'audienceTypeAssossiationHelper', this.getAudienceTypeList.filter(audienceType => audienceType.id == pricingRow.audienceTypeAssossiation)[0]);
                if (pricingRow.componentRuleType == null) {
                    pricingRow.componentRuleType = 0;
                }
            }

            if (this.audienceTypeGroups.length > 0) {
                this.validateGenderPriceNames(this.audienceTypeGroups);
            }
            this.updateFlagsIfEventEdit();
            // Whenever add or remove participants reavalidate
            this.recomputeAndEmitValidity();
		},
		audienceTypeGroups: {
			deep: true,
			handler(newVal, oldVal) {
				// Iterate through each object in audienceTypeGroups
				newVal.forEach((group, index) => {
					// Watch for changes in the groupName property of each object
					this.$watch(
					() => group.groupName,
					(newGroupName, oldGroupName) => {
						this.$nextTick(() => {
							const isValid = !this.hasRepeatedTypeGroupsNames(this.audienceTypeGroups) && !this.hasEmptyNames(this.audienceTypeGroups);
                            this.setIsFormValid = isValid;
                            this.recomputeAndEmitValidity();
						});
					}
					);
				});
			}
		}
    },
    computed: {
        ...mapGetters([
            'getVatTypes',
            'getModal',
            'getAudienceTypeList',
            'getProductEditPriceData',
            'getExtras',
        ]),
        isPerOrderAudienceValid() {
            return isPerOrderAudienceValid(this.selectedPrincingType, this.prices);
        },
        isPriceTypeDisabled() {
            return this.priceTypeConfig.isDisable;
        },
        priceType() {
            return this.priceTypeConfig.type;
        },
        hasDecomposedPrices() {
            const decomposedPrices = this.perOrderReferenceGenderPrice.productGenderPriceComponents;

            return decomposedPrices.length > 0;
        },
        activeGenderPrices() {
            this.setGroupPrices(this.prices);

            return this.setActiveGenderPrices(this.value);
        },
        activeGenderPricesAssociation() {
			return this.setActiveGenderPricesAssociation(this.value).filter( i => i != null );
        },
        // This is used if PER ORDER - Do not delete
        genderPricesAvailableOptions() {
            // New Array of availaible genderPrices options (eg: [Adult, Infant, etc])
            let output = this.audienceTypes.filter(audienceItem => {
                // New Array of ACTIVE genderPrices with their Association
                const allActiveGenderPrices = this.activeGenderPrices.concat(this.activeGenderPricesAssociation);
                
                return !allActiveGenderPrices.find(genderPrice => {
                    if(genderPrice){
                        return genderPrice.id == audienceItem.id;
                    } else {
                        return false;
                    }
                })
            })

            // If price is Per Order we will hide all audiences that have occupancy higher than 1
            if (this.selectedPrincingType.id === PricingTypes.PerOrder) {
                return output.filter(audience => {return audience.occupancy <= 1});
            } else {
                // If is price Per Person we show all gender prices
                return output;
            }
        },
        prices:{
            get() {
                return this.value;
            },
            set(newVal) {
                this.$emit('input', newVal);
            }
        },
        taxes() {
            return this.getVatTypes;
        },
        audienceTypes() {
            return this.getAudienceTypeList;
        },
        perOrderReferenceGenderPrice() {
            let output = this.prices.find(price => price.isExcludedFromBilling == false);
            
            if (output !== undefined) {
                return output;
            } else {
                return this.prices[0];
            }
        },
        types() {
            const options = [
                { id: PricingTypes.PerOrder,  description: 'Per Order'  },
                { id: PricingTypes.PerPerson, description: 'Per Person' },
                { id: PricingTypes.PerGroup,  description: 'Per Group'  }
            ];

            if (!Array.isArray(this.prices)) {
                this.selectedPrincingType = options[0] || null;
                
                return options;
            }
            if (this.prices.length === 0) {
                this.selectedPrincingType = options.find(option => option.id === PricingTypes.PerOrder) || options[0] || null;

                return options;
            }
            if (this.hasBackupedPricingType) {
                this.setBackupedType;

                return options;
            }
            const currentTypeId = this.prices[0] && this.prices[0].genderPriceType;
            this.selectedPrincingType = options.find(option => option.id === currentTypeId) || options.find(option => option.id === PricingTypes.PerOrder) || options[0] || null;

            return options;
        },
        setBackupedType() {
            // 1 assign prop value to a data property, so we can set it back to null after apply the backup
            this.hasBackupedPricingType = this.backupedPricingType;
            // 2 apply the backup to this data property
            this.selectedPrincingType = this.hasBackupedPricingType;
            // 3 now set this data property to null again
            this.hasBackupedPricingType = null;
        },
		setIsFormValid: {
			get() {
				return this.isFormValid;
			},
			set(newVal) {
				let isValid;

                if (!this.disabled && this.selectedPrincingType) {
                    if (this.selectedPrincingType.id === PricingTypes.PerOrder) {
                        isValid = newVal;
                    } else if (this.selectedPrincingType.id === PricingTypes.PerPerson) {
                        isValid = newVal;
                    } else { // Per Group dont do nothing because this have hes own validations already exemple : decomposition/tiers
                        isValid = true;
                    }
                } else {
                    isValid = true;
                }

                this.$emit('isReadyToSubmitPricingManager', isValid);
                this.isFormValid = isValid;
			}
		}
    },
    methods: {
        ...mapActions([
            'openModal',
            'updateroductEditPriceData',
            'setGroupPrices'
        ]),
        // Returns the validity for the current pricing type.
        computePricingValidityForCurrentType() {
            if (this.selectedPrincingType && this.selectedPrincingType.id === PricingTypes.PerOrder) {
                return this.isPerOrderAudienceValid;
            }
            return true;
        },
        recomputeAndEmitValidity() {
            const isValid = this.computePricingValidityForCurrentType();
            this.setIsFormValid = isValid;

            const eventValidity = (this.selectedPrincingType && this.selectedPrincingType.id === PricingTypes.PerOrder)
                ? isValid
                : true;
            this.$store.dispatch('eventFormState/setHasPriceErrors', !eventValidity);
        },
        hasPriceGroupDecompositionError(isValid) {
            this.$store.dispatch('eventFormState/setHasPriceGroupErrors', !isValid);
        },
        validateCustomNames: function() {
            this.markRepeatedCustomNames();
        },
        markRepeatedCustomNames() {
            const descriptionsCount = {};

            // First step: Count the occurrences of each ‘audienceTypeDescription’
            this.prices.forEach((item) => {
                if (item.audienceType === 500) {
                    const desc = item.audienceTypeDescription.trim();
                    
                    descriptionsCount[desc] = (descriptionsCount[desc] || 0) + 1;
                }
            });

            // Second step: Mark objects with ‘isRepeated’ when necessary
            this.prices.forEach((item) => {
                if (item.audienceType === 500) {
                    const desc = item.audienceTypeDescription.trim();
                    
                    if (descriptionsCount[desc] > 1) {
                        this.$set(item, 'isRepeated', true);
                    } else {
                        this.$delete(item, 'isRepeated');
                    }
                } else {
                    this.$delete(item, 'isRepeated');
                }
            });
        },
		groupPricesBy(prices, key) {
			return _.chain(prices)
                .groupBy(key) // Group by key (audienceTypeGroup) (the name of the group defined from backend side)
                .map((prices, targetKey) => {
					let groupName = targetKey == 'null' || targetKey == "" || targetKey == undefined || !targetKey ? null : targetKey // https://github.com/lodash/lodash/issues/3060
                    return {
                        groupName: groupName,
                        groupPrices: prices,
                        allPrices: prices,
                        prices: prices
                    };
                })
                .sort((a, b) => +(a.groupName !== null) - (b.groupName !== null))
                .value();
		},
        changePricesAudienceTypeGroupNames(currentGroupNameModel, index) {
            if (_.isEmpty(currentGroupNameModel.groupName.trim())) {
                currentGroupNameModel.isEmptyName = true;
            } else {
                currentGroupNameModel.isEmptyName = false;
            }

            this.validateGenderPriceNames(this.audienceTypeGroups);
			this.currentGroupNameProp = currentGroupNameModel;
			this.currentGroupNameIndex = index;

            // Important here
            this.$forceUpdate();
        },
        validateGenderPriceNames(array) {
            let groupNames = {};
            
            // Array iteration to count how many times each groupName appears
            array.forEach(obj => {
                if (obj.groupName !== null) {
                    const groupName = obj.groupName.toLowerCase().trim();
                    if (groupName in groupNames) {
                        groupNames[groupName].count++;
                    } else {
                        groupNames[groupName] = { count: 1 };
                    }
                }
            });
            
            // Array iteration again to set repeatedName based on the count
            array.forEach(obj => {
                if (obj.groupName !== null) {
                    const groupName = obj.groupName.toLowerCase().trim();
                    obj.repeatedName = groupNames[groupName].count > 1;
                }
            });
        },
        setActiveGenderPrices(audTypeObj) {
            return audTypeObj.map(genderPrice => {
                if (genderPrice.audienceTypeHelper && genderPrice.audienceType !== 500) {
                    return genderPrice.audienceTypeHelper;
                } else {
                    return null;
                }
            })
        },
        setActiveGenderPricesAssociation(audTypeObj) {
            return audTypeObj.map(genderPrice => {
                if (genderPrice.audienceTypeAssossiation) {
                    return genderPrice.audienceTypeAssossiationHelper;
                } else {
                    return null;
                }
            });
        },
        priceIncludeTaxesChanged(val) {
            this.value.map(i => i.isTaxIncludedInPrice = val);
            this.updateFlagsIfEventEdit();
        },
        customPerPersonTaxes(row) {
            let taxes = [];

            for (let service of row) {
                if (service.component.selectedPrice && taxes.indexOf(service.component.selectedPrice.vatType+'%') == -1) {
                    taxes.push(service.component.selectedPrice.vatType+'%');
                } else {
                    taxes.push(service.component.vatType+'%');
                }
            }

            return taxes.join(', ');
        },
        updateType(selectedType) {
            this.updateFlagsIfEventEdit();

            let previousIncludeTax = this.prices[0].isTaxIncludedInPrice;

            if (selectedType.id === PricingTypes.PerOrder) { // Per order
                if (this.prices[0].genderPriceType !== PricingTypes.PerOrder) {
                    this.prices = [
                        {
                            genderPriceType: PricingTypes.PerOrder, // Per order
                            isExcludedFromBilling: false,
                            vatType: 0,
                            value: 0,
                            isTaxIncludedInPrice: previousIncludeTax,
                            currency: "€",
                            productGenderPriceComponents: [],
                        }
                    ]

                    this.$delete(this.group, 'passengerSettings');
                    if (this.group.backupGroup) this.$delete(this.group.backupGroup, 'passengerSettings');
                }
                // Re-evaluate validity immediately after switching to Per Order
                this.$nextTick(() => this.recomputeAndEmitValidity());
            } else if (selectedType.id === PricingTypes.PerPerson) { // Per person

                if (this.prices[0].genderPriceType !== PricingTypes.PerPerson) {
                    this.prices = [
                        {
                            genderPriceType: PricingTypes.PerPerson, // Per person
                            audienceType: this.audienceTypes[0].id,
                            audienceTypeGroup: null,
                            audienceTypeDescription: this.audienceTypes[0].description,
                            audienceTypeHelper: this.audienceTypes[0],
							audienceTypeOccupancy: 1,
                            value: 0,
                            isTaxIncludedInPrice: previousIncludeTax,
                            currency: '€',
                            vatType: this.taxes[0].id,
                            vatTypeHelper: this.taxes[0],
                            dependencySettings: null,
                            genderPriceDependencies: [],
                            productGenderPriceComponents: [],
                        }
                    ]

                    this.$delete(this.group, 'passengerSettings');
                    if (this.group.backupGroup) this.$delete(this.group.backupGroup, 'passengerSettings');
                }
                // recalculate when switch
                this.$nextTick(() => this.recomputeAndEmitValidity());
            } else { // Per group
                if (this.prices[0].genderPriceType !== PricingTypes.PerGroup) {
                    this.prices = [
                        {
                            id: 0,
                            genderPriceType: PricingTypes.PerGroup, // Per group
                            hashedAudience: this.audienceTypes[0].id,
                            audienceType: this.audienceTypes[0].id,
                            audienceTypeGroup: null,
                            audienceTypeDescription: this.audienceTypes[0].description,
                            dependencySettings: null,
                            genderPriceDependencies: [],
                            productGenderPriceComponents: [],   
                            value: 0,
                            isTaxIncludedInPrice: previousIncludeTax,
                            tieredConfigurations: null
                        }
                    ]

                    this.$set(this.group, 'passengerSettings', this.createPassengerSettings());
                    if (this.group.backupGroup) this.$set(this.group.backupGroup, 'passengerSettings', this.createPassengerSettings());
                }
                // recalculate when switch
                this.$nextTick(() => this.recomputeAndEmitValidity());
            }
        },
        createPassengerSettings() {
            return {
                format: 1,
                friendlyFormat: "PerCategory",
                productGenderPriceComponents: [],
                configurations: [
                    { lowerBound: 1, upperBound: null, vat: 0, price: 0 },
                ]
            };
        },
        updateTaxType(row, selectedVatType){
            this.updateFlagsIfEventEdit();

            if (!selectedVatType) {
                selectedVatType = this.taxes[0];
            }
            row.vatType = selectedVatType.id;
        },
        addNewCustomPriceGroup() {
            if (this.disabled) {
                return false;
            }

            if (this.audienceTypeGroups.length > 0 && this.hasRepeatedTypeGroupsNames(this.audienceTypeGroups)) {
                this.$toasted.error('Please add first other Group Name!');
            } else if (this.audienceTypeGroups.length > 0 && this.hasEmptyNames(this.audienceTypeGroups)) {
                this.$toasted.error('Please add a Group Name!');
            } else {
                this.updateFlagsIfEventEdit();
    
                const defaultRow = {
                    refId: _.last(this.prices).id != undefined ? _.last(this.prices).id +1 +'-'+ new Date().getTime() : new Date().getTime(), // unique id for newly created, so we can identify the item to delete
                    genderPriceType: this.selectedPrincingType.id,
                    audienceType: this.audienceTypes[0].id,
                    audienceTypeGroup: this.createNewGroupName(this.audienceTypeGroups),
                    audienceTypeDescription: this.audienceTypes[0].description,
                    audienceTypeHelper: this.audienceTypes[0],
                    isExcludedFromBilling: this.selectedPrincingType.id === PricingTypes.PerOrder ? true : null,
                    isTaxIncludedInPrice: this.value[0].isTaxIncludedInPrice,
                    componentRuleType:0, // Fixed type by default
                    value: 0,
                    currency: '€',
                    vatType: this.taxes[0].id,
                    vatTypeHelper: this.taxes[0],
                    dependencySettings: null,
                    genderPriceDependencies: [],
                    productGenderPriceComponents: [],
                    audienceTypeOccupancy: 1
                }

                this.prices.push(defaultRow);
                this.setGroupPrices(this.prices);
                this.$forceUpdate();
            }
        },
        createNewGroupName(array) {
            const groupNamePrefix = 'Price Group';

            // Checks if the array exists and has at least one element
            if (array && Array.isArray(array) && array.length > 0) {
                const hasNullName = array.some(obj => obj.groupName === null);

                // If available, finds the next available number and returns the corresponding name
                if (hasNullName) {
                    const numbers = new Set();
                    array.forEach(obj => {
                        if (obj.groupName && obj.groupName.startsWith(groupNamePrefix)) {
                            const num = parseInt(obj.groupName.slice(groupNamePrefix.length).trim());
                            if (!isNaN(num)) {
                                numbers.add(num);
                            }
                        }
                    });

                    // Find the next available number
                    let index = 1;
                    while (numbers.has(index)) {
                        index++;
                    }

                    return `${groupNamePrefix} ${index}`;
                }

                // Check if any groupName is an empty string
                const hasEmptyName = array.some(obj => typeof obj.groupName === 'string' && obj.groupName.trim() === '');
                if (hasEmptyName) {
                    return 'Price Group 1';
                }

                // Finds all the numbers used and their prefixes
                const numbers = new Set();
                const prefixLength = groupNamePrefix.length;
                array.forEach(obj => {
                    const name = obj.groupName.trim();
                    if (name.startsWith(groupNamePrefix)) {
                        const suffix = name.slice(prefixLength).trim();
                        const num = suffix ? parseInt(suffix) : 0;
                        if (!isNaN(num)) {
                            numbers.add(num);
                        }
                    }
                });

                // Find the next available number
                let index = 1;
                while (numbers.has(index)) {
                    index++;
                }

                return `${groupNamePrefix} ${index}`;
            } else {
                // If the array does not exist or is empty, returns 'Price Group 1'
                return 'Price Group 1';
            }
        },
        // This is used if PER ORDER - Do not delete
        addRow() {
            if (this.disabled) {
                return false;
            }

            this.updateFlagsIfEventEdit();

            let defaultRow = {
                genderPriceType: this.selectedPrincingType.id,
                audienceType: this.genderPricesAvailableOptions[0].id,
                audienceTypeDescription: this.genderPricesAvailableOptions[0].description,
                audienceTypeHelper: this.genderPricesAvailableOptions[0],
                isExcludedFromBilling: this.selectedPrincingType.id === PricingTypes.PerOrder ? true : null,
                isTaxIncludedInPrice: this.value[0].isTaxIncludedInPrice,
                value: 0,
                currency: '€',
                vatType: this.taxes[0].id,
                vatTypeHelper: this.taxes[0],
                productGenderPriceComponents: []
            }

            this.prices.push(defaultRow);
            this.$forceUpdate();
            // Adding a participant may satisfy Per Order rule
            this.recomputeAndEmitValidity();
        },
        deletePrincingType(index) {
            if (index !== -1) {
                this.prices.splice(index, 1);
                this.updateFlagsIfEventEdit();
                // Removing a participant may violate Per Order rule
                this.recomputeAndEmitValidity();
            }
        },
        deletePrincingTypePG(priceRowToDelete) {
            if (this.audienceTypeGroups.length > 0 && this.hasRepeatedTypeGroupsNames(this.audienceTypeGroups)) {
                this.$toasted.error('Please add first other Group Name!');
            } else if (this.audienceTypeGroups.length > 0 && this.hasEmptyNames(this.audienceTypeGroups)) {
                this.$toasted.error('Please add a Group Name!');
            } else {
                const newPrices = this.removeDependencies(this.prices, priceRowToDelete, 'individual');
                this.prices = newPrices;
                this.setGroupPrices(newPrices);
                this.updateFlagsIfEventEdit();
                this.recomputeAndEmitValidity();
            }
        },
        removeGroupOfPrices(priceGroup) {
            if (this.disabled) {
                return false;
            }

            if (this.audienceTypeGroups.length > 0) {
                if (this.hasRepeatedTypeGroupsNames(this.audienceTypeGroups)) {
                    this.$toasted.error('Please add first other Group Name!');
                    return;
                }

                if (this.isEmptyNameToDelete(this.audienceTypeGroups, priceGroup)) {
                    this.deleteGroup(priceGroup);
                    return;
                }

                if (this.hasEmptyNames(this.audienceTypeGroups)) {
                    this.$toasted.error('Please add a Group Name!');
                    return;
                }
            }

            this.deleteGroup(priceGroup);
        },
        deleteGroup(priceGroup) {
            const newPrices = this.removeDependencies(this.prices, priceGroup.groupPrices, 'group');
            this.prices = newPrices;
            this.setGroupPrices(newPrices);
            this.updateFlagsIfEventEdit();
            this.recomputeAndEmitValidity();
        },
        removeDependencies(prices, pricesToDeleteList, mode) {
            // Ensure that pricesToDeleteList is always an array
            const pricesToDeleteArray = Array.isArray(pricesToDeleteList) ? pricesToDeleteList : [pricesToDeleteList];

            let filteredPrices;
            let removePrices;

            if (mode === 'individual') {
                filteredPrices = prices.filter(item => item.id !== pricesToDeleteList.id || item.refId !== pricesToDeleteList.refId);
            } else if (mode === 'group') {
                // Get price ids/refIds to be removed and add it to a set to compare later
                const pricesToRemoveSet = new Set(pricesToDeleteArray.map(p => p.refId || p.id));
                // Get price objects to be removed in cases where there is more than one price in the group
                removePrices = pricesToDeleteArray.filter(p => pricesToRemoveSet.has(p.refId || p.id));
                // Filter ‘prices’ to exclude prices to remove
                filteredPrices = prices.filter(price => !pricesToRemoveSet.has(price.id || price.refId));
            }

            const updatedPrices = filteredPrices.map(price => {
                // Check if has dependencies
                if (!price.genderPriceDependencies || price.genderPriceDependencies.length === 0) {
                    return price;
                }
                // Deletes the dependencies related to the deleted price or deleted prices in group
                const updatedDependencies = price.genderPriceDependencies.reduce((acc, gdp) => {
                    let shouldRemove = false;

                    if (mode === 'individual') {
                        const priceToDelete = pricesToDeleteArray[0];
                        const extraDescription = `${priceToDelete.audienceTypeGroup} - ${priceToDelete.audienceTypeDescription}`;

                        shouldRemove = (
                            gdp.genderPriceDependsOn.audienceType === priceToDelete.audienceType &&
                            (
                                gdp.genderPriceDependsOn.audienceTypeDescription === priceToDelete.audienceTypeDescription ||
                                gdp.genderPriceDependsOn.audienceTypeDescription === extraDescription
                            ) &&
                            gdp.genderPriceDependsOn.audienceTypeGroup === priceToDelete.audienceTypeGroup
                        );
                    } else if (mode === 'group') {
                        shouldRemove = removePrices.some(removePrice => {
                            const extraDescription = `${removePrice.audienceTypeGroup} - ${removePrice.audienceTypeDescription}`;

                            return (
                                gdp.genderPriceDependsOn.audienceType === removePrice.audienceType &&
                                (
                                    gdp.genderPriceDependsOn.audienceTypeDescription === removePrice.audienceTypeDescription ||
                                    gdp.genderPriceDependsOn.audienceTypeDescription === extraDescription
                                ) &&
                                gdp.genderPriceDependsOn.audienceTypeGroup === removePrice.audienceTypeGroup
                            );
                        });
                    }

                    if (shouldRemove) {
                        if (gdp.isNewDep) {
                            // Remove dependencie directly if is new
                            return acc;
                        } else {
                            // Update dependencie prop to delete if is already saved
                            acc.push({ ...gdp, isDeleted: true });
                            return acc;
                        }
                    }

                    // If not to delete keeps the dependency as it is
                    acc.push(gdp);
                    return acc;
                }, []);

                return {
                    ...price,
                    genderPriceDependencies: updatedDependencies
                };
            });

            return updatedPrices;
        },
        openEditPrice(priceRow) {
            if (this.disabled) {
                return false;
            }

            if (this.getExtras.length === 0) {
                this.noServicesErrorMessage();
                
                return;
            }

            this.updateFlagsIfEventEdit();
            this.updateroductEditPriceData(priceRow);

            // If we open the "Edit Price" modal and we are already on a modal, then we need to seed a callback to re-open the previous modal
            if(this.getModal.show === false){
                this.openModal('ProductEditPrice');
            } else {
                let currentModal = this.getModal.template;
                this.openModal({
                    name: 'ProductEditPrice',
                    callback: () => {
                        this.openModal(currentModal);
                    }
                });
            }
        },
        customPerPersonTotal(row) {
            let total = 0;
            for (let service of row) {
                if (service.component.selectedPrice) {
                    total += service.component.selectedPrice.grossprice;
                } else {
                    total = this.getProductEditPriceData
                        ? Number(this.perOrderReferenceGenderPrice.value)
                        : this.perOrderReferenceGenderPrice.grossprice;
                }
            }
            return (total).toFixed(2).replace(".", ",");
        },
        updateFlagsIfEventEdit() {
            // Adding a updateflag to Prices on editEvent | mixin.js
            if (this.isEventEditMode) this.eventActivateUpdateFlag('Prices');
        }
    },
    components: {
        vSelect: extendedVSelect,
        PriceGroup,
        PriceManagerRow,
        PricePerGroup
    }
}
</script>

<style lang="scss" scoped>
    .price-group-wrapper {
        border-left: 0 solid #fff;
        margin-left: 0;
        margin-right: 0;
        background: #fff;
        border-top: 1px solid #e5e9eb;
        
        .price-group-item {
            padding-left: 0;
            padding-right: 0;
        }
        & .price-group-item-header {border-bottom: 1px solid #dbdfe2; }
        & .price-group-item-header, & .price-group-item-body {margin-right: 0; }
    }

    .price-group-wrapper:nth-child(even) {
        background: #fff;
        border-left: 0 solid #fff;
        & .price-group-item-header {background: #fff;}
    }

    .price-group-wrapper:nth-child(odd) {
        background: #f9f9f9;
        border-left: 0 solid #f9f9f9;
        & .price-group-item-header, & .price-group-item-body {background: #f9f9f9;}
    }

    .error-field {
        border-color: #e73f47;
    }
</style>



// WEBPACK FOOTER //
// PricingManager.vue?25fc26d7